import { DateTime } from "luxon";
import { IModel, Model, ModelRecord } from "@common/models/Model";
import { defaultTo } from "lodash";

export interface IHospitalPrescriptionEventModel extends IModel {
    hospitalPrescriptionEventId: number;
    hospitalPrescriptionId: number;
    hospitalPrescriptionEventTypeId: number;
    visitSalesItemId: number | undefined;
    salesItemOptionId: number;
    integrationResponsePayloadStorageContentId: number | undefined;
    wasSuccessful: boolean;
    note: string | undefined;
    hospitalPrescriptionEventTypeName: string;
    visitSalesItemSalesItemName: string | undefined;
    integrationResponsePayloadStorageContentUrl: string | undefined;
    eventDate: string;
}

export class HospitalPrescriptionEventModel extends Model implements ModelRecord<IHospitalPrescriptionEventModel> {
    hospitalPrescriptionEventId: number;
    hospitalPrescriptionId: number;
    hospitalPrescriptionEventTypeId: number;
    visitSalesItemId: number | undefined;
    salesItemOptionId: number;
    integrationResponsePayloadStorageContentId: number | undefined;
    wasSuccessful: boolean;
    note: string | undefined;
    hospitalPrescriptionEventTypeName: string;
    visitSalesItemSalesItemName: string | undefined;
    integrationResponsePayloadStorageContentUrl: string | undefined;
    eventDate: DateTime;

    constructor(params?: Partial<IHospitalPrescriptionEventModel>) {
        super(params);
        this.hospitalPrescriptionEventId = defaultTo(params?.hospitalPrescriptionEventId, 0);
        this.hospitalPrescriptionId = defaultTo(params?.hospitalPrescriptionId, 0);
        this.hospitalPrescriptionEventTypeId = defaultTo(params?.hospitalPrescriptionEventTypeId, 0);
        this.visitSalesItemId = defaultTo(params?.visitSalesItemId, 0);
        this.salesItemOptionId = defaultTo(params?.salesItemOptionId, 0);
        this.integrationResponsePayloadStorageContentId = defaultTo(params?.integrationResponsePayloadStorageContentId, 0);
        this.wasSuccessful = defaultTo(params?.wasSuccessful, false);
        this.note = defaultTo(params?.note, "");
        this.hospitalPrescriptionEventTypeName = defaultTo(params?.hospitalPrescriptionEventTypeName, "");
        this.visitSalesItemSalesItemName = defaultTo(params?.visitSalesItemSalesItemName, "");
        this.integrationResponsePayloadStorageContentUrl = defaultTo(params?.integrationResponsePayloadStorageContentUrl, "");
        this.eventDate = params?.eventDate ? DateTime.fromISO(params?.eventDate, { zone: "utc" }) : DateTime.utc();
    }
}
